import { FieldDimensionId } from '@core/constants/FieldDimension';
import {
    IFormInputType,
    IDimensionUnit,
    IFormFieldDimension,
    IFormFieldDimensionDefaultValueKey,
} from '../../../interfaces/Form';

export const fieldsLegsDimension: IFormFieldDimension = {
    [FieldDimensionId.Height]: {
        value         : undefined,
        type          : IFormInputType.Range,
        unit          : IDimensionUnit.Centimeters,
        step          : 50,
        range         : { min: 300, max: 1200 },
        required      : true,
        defaultValue  : 750,
        defaultValues : [
            [IFormFieldDimensionDefaultValueKey.CoffeeTable, 450],
            [IFormFieldDimensionDefaultValueKey.Table, 750],
            [IFormFieldDimensionDefaultValueKey.BarTable, 1200],
        ],
    },
};

export const fieldsLowTableLegsDimension: IFormFieldDimension = {
    [FieldDimensionId.Height]: {
        value         : undefined,
        type          : IFormInputType.Range,
        unit          : IDimensionUnit.Centimeters,
        step          : 10,
        range         : { min: 200, max: 600 },
        required      : true,
        defaultValue  : 300,
        defaultValues : [
            [IFormFieldDimensionDefaultValueKey.CoffeeTable, 450],
        ],
    },
};

export const fieldsLowNestingTableLegsDimension: IFormFieldDimension = {
    [FieldDimensionId.Height]: {
        value         : undefined,
        type          : IFormInputType.Range,
        unit          : IDimensionUnit.Centimeters,
        step          : 10,
        range         : { min: 200, max: 600 },
        required      : true,
        defaultValue  : 300,
        defaultValues : [
            [IFormFieldDimensionDefaultValueKey.CoffeeTable, 450],
        ],
    },
    [FieldDimensionId.HeightTable2]: {
        value         : undefined,
        type          : IFormInputType.Range,
        unit          : IDimensionUnit.Centimeters,
        step          : 10,
        range         : { min: 150, max: 500 },
        required      : true,
        defaultValue  : 200,
        defaultValues : [
            [IFormFieldDimensionDefaultValueKey.CoffeeTable, 450],
        ],
    },
};

export default fieldsLegsDimension;
